import { render } from "./SocialMediaButton.vue?vue&type=template&id=9901a536"
import script from "./SocialMediaButton.vue?vue&type=script&lang=ts"
export * from "./SocialMediaButton.vue?vue&type=script&lang=ts"

import "./SocialMediaButton.vue?vue&type=style&index=0&id=9901a536&lang=scss"
script.render = render

export default script